import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { colors } from '../theme/tokens';

export interface DefinitionItem {
    label: React.ReactNode;
    value: React.ReactNode;
}

/* Label / value rows (cycle details, profile summaries). Stacks the label above the value on mobile. */
const DefinitionList: React.FC<{ items: (DefinitionItem | false | null | undefined)[]; isMobile?: boolean }> = ({ items, isMobile = false }) => (
    <Box component="dl" sx={{ m: 0 }}>
        {items.filter(Boolean).map((item, i) => {
            const { label, value } = item as DefinitionItem;
            return (
                <Box
                    key={i}
                    sx={{
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        gap: isMobile ? 0.25 : 3,
                        py: 1.5,
                        borderTop: i ? '1px solid #f0f3f8' : 'none',
                    }}
                >
                    <Typography component="dt" sx={{ width: isMobile ? 'auto' : 220, flex: 'none', fontSize: 13, fontWeight: 500, color: colors.textGrey }}>
                        {label}
                    </Typography>
                    <Box component="dd" sx={{ m: 0, flex: 1, minWidth: 0, fontSize: 14, wordBreak: 'break-word' }}>
                        {value}
                    </Box>
                </Box>
            );
        })}
    </Box>
);

export default DefinitionList;
